export default "__VITE_ASSET__UAHOXy9T__"